/**
 * Texts for Notifications page
 */
export const notificationsPageText = {
    title: 'Notifiche recenti in-app',
    titleMeta: 'Visualizzazione delle notifiche in-app recenti CamAPS FX',
    descriptionMeta: 'Ecco il testo delle recenti notifiche in-app relative ad aggiornamenti delle app, avvisi di sicurezza, aggiornamenti del manuale dell\'utente',
    keywords: 'Notifiche' ,
    localeMeta: 'it',

    heading: 'Notifiche recenti in-app',
    subheading: '',

    header_133:'',
    body_133:'',

    header_132:'Aggiornamento dell\'app Android (YpsoPump only) 28/10/2026',
    body_132:'Caro utente di CamAPS FX, una nuova versione dell\'applicazione 1.4(195) sarà disponibile nei prossimi giorni. Si prega di scegliere il proprio orario di aggiornamento preferito disattivando l\'aggiornamento automatico per CamAPS FX nel Google Play Store. Se hai domande, contatta il servizio clienti mylife-Diabetescare.',

    header_131:'',
    body_131:'',

    header_130:'Aggiornamento necessario (solo YpsoPump) 20/10/2026',
    body_130:'Aggiornamento necessario! Questa versione di CamAPS FX potrebbe bloccarsi e riavviarsi più frequentemente. Aggiorna ORA all\'ultima versione tramite Google Play Store. La versione 1.4(190) dell\'app verrà dismessa il 20/11/2026. Dopo questa data, “Auto Mode” non sarà più disponibile fino a quando l\'app non verrà aggiornata. L\'erogazione di insulina tramite la pompa continuerà.',

    header_129:'',
    body_129:'',

    header_128:'Aggiornamento del manuale utente (solo YpsoPump) 15/10/2026',
    body_128:'È ora disponibile una versione aggiornata del manuale utente. È possibile accedervi dal menu principale di CamAPS FX selezionando Aiuto dopo l\'aggiornamento all\'ultima versione dell\'app.',

    header_127:'',
    body_127:'',

    header_126:'Aggiornamento dell\'app Android (YpsoPump only) 02/10/2026',
    body_126:'Caro utente di CamAPS FX, una nuova versione dell\'applicazione 1.4(194) sarà disponibile nei prossimi giorni. Si prega di scegliere il proprio orario di aggiornamento preferito disattivando l\'aggiornamento automatico per CamAPS FX nel Google Play Store. Se hai domande, contatta il servizio clienti mylife-Diabetescare.',

    header_125:'',
    body_125:'',

    header_124:'',
    body_124:'',

    header_123:'',
    body_123:'',

    header_122:'Aggiornamento app iOS (YpsoPump only) 28/09/2026',
    body_122:'Caro utente di CamAPS FX, una NUOVA VERSIONE dell\'applicazione 1.4(196) sarà disponibile nei prossimi giorni. DISATTIVA GLI AGGIORNAMENTI AUTOMATICI DI CamAPS FX nell\'App Store per selezionare il momento dell\'aggiornamento preferito. Se hai domande, ti preghiamo di contattare il Servizio Clienti mylife-Diabetescare.',

    header_121:'Rilascio di Apple iOS 27 11/09/2026',
    body_121:'Apple rilascerà presto iOS 27. Per garantire un utilizzo senza interruzioni dell\'applicazione CamAPS FX, verifica la compatibilità dello smartphone e del sistema operativo sul sito web del produttore del sensore PRIMA di aggiornare il tuo iPhone a iOS 27. Gli aggiornamenti automatici potrebbero essere ATTIVATI per impostazione predefinita nelle impostazioni del telefono; considera la possibilità di DISATTIVARLI.',

    header_120:'',
    body_120:'',

    header_119:'Aggiornamento del manuale utente (solo YpsoPump) 10/09/2026',
    body_119:'È ora disponibile una versione aggiornata del manuale utente. È possibile accedervi dal menu principale di CamAPS FX selezionando Aiuto dopo l\'aggiornamento all\'ultima versione dell\'app.',

    header_118:'Aggiornamento dell\'app Android (YpsoPump only) 07/09/2026',
    body_118:'Caro utente di CamAPS FX, una nuova versione dell\'applicazione 1.4(193) sarà disponibile nei prossimi giorni. Si prega di scegliere il proprio orario di aggiornamento preferito disattivando l\'aggiornamento automatico per CamAPS FX nel Google Play Store. Se hai domande, contatta il servizio clienti mylife-Diabetescare.',

    header_117:'',
    body_117:'',

    header_116:'',
    body_116:'',

    header_115:'',
    body_115:'',

    header_114:'',
    body_114:'',

    header_113:'',
    body_113:'',

    header_112:'',
    body_112:'',

    header_111:'Disattivazione delle versioni Android inferiori a 1.4(192) (Ypsopump only) 03/08/2026',
    body_111:'Gentile utente CamAPS FX, per motivi di cybersecurity, le versioni INFERIORI a 1.4(192) saranno INTERROTTE il 31/08/2026. Assicurarsi che l\'app sia AGGIORNATA alla versione 1.4(192) prima di questa data. In caso di domande, contattare il servizio clienti mylife-Diabetescare.',

    header_110:'',
    body_110:'',
    body_110_link_text:'',
    body_110_end: '',
    body_110_link:'',

    header_109:'Rilascio di Android OS 17 24/06/2026',
    body_109:'Android rilascerà presto OS 17. Per garantire un utilizzo senza interruzioni dell\'applicazione CamAPS FX, verifica la compatibilità dello smartphone e del sistema operativo sul sito web del produttore del sensore PRIMA di aggiornare il tuo dispositivo Android a OS 17. Gli aggiornamenti automatici potrebbero essere ATTIVATI per impostazione predefinita nelle impostazioni del telefono; DISATTIVALI.',

    header_108:'Dexcom G7 è disponibile (solo Ypsopump) 23/06/2026',
    body_108:'L\'integrazione del sistema CGM Dexcom G7 è ora disponibile! Gli utenti che passano da Dexcom G6 possono trovare sul nostro sito web una guida alla transizione, indicazioni per la risoluzione dei problemi e una panoramica dei sistemi CGM compatibili: www.mylife-diabetescare.com.',

    header_107:'',
    body_107:'',

    header_106:'Aggiornamento del manuale utente (solo YpsoPump) 22/06/2026',
    body_106:'È ora disponibile una versione aggiornata del manuale utente. È possibile accedervi dal menu principale di CamAPS FX selezionando Aiuto.',

    header_105:'Dexcom G7 è disponibile (solo YpsoPump; solo Dexcom G6) 19/06/2026',
    body_105:'Solo CH - Nuovo avviso: è ora disponibile l\'integrazione del sistema CGM Dexcom G7! Gli utenti che passano dal Dexcom G6 troveranno istruzioni dettagliate su come procedere sul nostro sito web: www.mylife-diabetescare.com.',

    header_104:'',
    body_104:'',

    header_103:'Aggiornamento dell\'app Android (YpsoPump only) 12/06/2026',
    body_103:'Solo per IT - Caro utente di mylife CamAPS FX, una nuova versione dell\'applicazione 1.4(192) sarà disponibile nei prossimi giorni. Si prega di scegliere il proprio orario di aggiornamento preferito disattivando l\'aggiornamento automatico per CamAPS FX nel Google Play Store. Se hai domande, contatta il servizio clienti mylife-Diabetescare.',

    header_102:'',
    body_102:'',

    header_101:'Dexcom G7 è disponibile (solo YpsoPump; solo Android) 09/06/2026',
    body_101:'Solo per CH - L\'integrazione del sistema CGM Dexcom G7 è ora disponibile! Gli utenti che passano dal Dexcom G6 possono trovare ulteriori informazioni, insieme a una panoramica dei sistemi CGM compatibili, sul nostro sito web: www.mylife-diabetescare.com.',

    header_100:'Aggiornamento dell\'app Android (solo YpsoPump) 05/06/2026',
    body_100:'Solo per CH - Gentile utente di CamAPS FX, una nuova versione di CamAPS FX, 1.4(192), sarà disponibile nei prossimi giorni. Per scegliere quando aggiornare, disattivare gli AGGIORNAMENTI AUTOMATICI nell Google Play Store. Gli utenti con versioni INFERIORI ad OS 13 NON potranno AGGIORNARE CamAPS FX a questa versione È ora disponibile una versione aggiornata del manuale utente.. Per qualsiasi domanda, contattare il servizio clienti mylife-Diabetescare.',

    header_99:'Dexcom G7 è disponibile (solo YpsoPump; solo iOS) 02/06/2026',
    body_99:'Solo per CH - L\'integrazione del sistema CGM Dexcom G7 è ora disponibile! Gli utenti che passano dal Dexcom G6 possono trovare ulteriori informazioni, insieme a una panoramica dei sistemi CGM compatibili, sul nostro sito web: www.mylife-diabetescare.com.',

    header_98:'Interruzione dei vecchi sistemi operativi 22/05/2026',
    body_98:'Mentre prepariamo il prossimo aggiornamento dell\'app, si prega di notare che CamAPS FX sarà supportata SOLO su telefoni compatibili con sensori con Android OS 13 o successivo oppure Apple iOS 18 o successivo. Dopo questo rilascio, gli utenti con telefoni con versioni INFERIORI ad Android OS 13 o iOS 18 NON potranno più AGGIORNARE o REINSTALLARE CamAPS FX.',

    header_97:'Aggiornamento dell\'app iOS 22/05/2026',
    body_97:'Gentile utente di CamAPS FX, una nuova versione di CamAPS FX, 1.4(195), sarà disponibile nei prossimi giorni. Per scegliere quando aggiornare, disattivare gli AGGIORNAMENTI AUTOMATICI nell\'App Store. Gli utenti con versioni INFERIORI ad Apple iOS 18 NON potranno AGGIORNARE CamAPS FX a questa versione. È ora disponibile una versione aggiornata del manuale utente. Per qualsiasi domanda, contattare il servizio clienti mylife-Diabetescare.',

    header_96:'Interruzione dei vecchi sistemi operativi 11/05/2026',
    body_96:'Solo per CH - Mentre prepariamo il prossimo aggiornamento dell\'app, si prega di notare che CamAPS FX sarà supportata SOLO su telefoni compatibili con sensori con Android OS 13 o successivo oppure Apple iOS 18 o successivo. Dopo questo rilascio, gli utenti con telefoni con versioni INFERIORI ad Android OS 13 o iOS 18 NON potranno più AGGIORNARE o REINSTALLARE CamAPS FX. Per qualsiasi domanda, contattare il servizio clienti mylife-Diabetescare.',

    header_95:'',
    body_95:'',

    header_94:'Aggiornamento Dexcom G7 (solo Ypsopump) 28/04/2026',
    body_94:'Solo per CH - Ci stiamo avvicinando alla compatibilità di Dexcom G7 con la sua app CamAPS FX! L\'integrazione dovrebbe essere disponibile in Svizzera tra la metà e la fine di maggio 2026. Ulteriori aggiornamenti seguiranno a breve.',

    header_93:'Disattivazione delle versioni iOS inferiori alla 1.4(193) (solo Ypsopump) 22/04/2026',
    body_93:'Gentile utente CamAPS FX, per motivi di cybersicurezza le VERSIONI INFERIORI alla 1.4(193) saranno DISATTIVATE il 30 aprile. Assicurati che la tua app sia AGGIORNATA alla versione 1.4(193) prima di questa data. Per qualsiasi domanda, contatta il Servizio Clienti mylife-Diabetescare.',

    header_92:'Disattivazione dei sistemi operativi precedenti 21/04/2026',
    body_92:'Per motivi di sicurezza informatica, a partire dal 30 giugno 2026, mylife CamAPS FX sarà supportato SOLO su telefoni compatibili con il sensore che eseguono i seguenti sistemi operativi: Android OS 13 e versioni successive e Apple iOS 18 e versioni successive. Gli utenti con sistemi operativi INFERIORI ad Android OS 13 o Apple iOS 18 NON potranno AGGIORNARE né REINSTALLARE mylife CamAPS FX dopo questa data.',

    header_91:'',
    body_91:'',
    body_91_link_text:'',
    body_91_end: '',
    body_91_link:'',

    header_90:'',
    body_90:'',

    header_89:'',
    body_89:'',

    header_88:'Aggiornamento Dexcom G7 (solo Ypsopump) 01/04/2026',
    body_88:'Ci siamo quasi! La compatibilità del sistema CGM Dexcom G7 con mylife CamAPS FX sarà disponibile entro l’estate 2026. Vi terremo aggiornati man mano che il lancio si avvicina.',

    header_87:'Disattivazione delle versioni iOS inferiori alla 1.4(193) (solo Ypsopump) 16/03/2026',
    body_87:'Gentile utente CamAPS FX, per motivi di cybersicurezza le VERSIONI INFERIORI alla 1.4(193) saranno DISATTIVATE il 31 marzo. Assicurati che la tua app sia AGGIORNATA alla versione 1.4(193) prima di questa data. Per qualsiasi domanda, contatta il Servizio Clienti mylife-Diabetescare.',

    header_86:'',
    body_86:'',
    body_86_link_text:'',
    body_86_end: '',
    body_86_link:'',

    header_85:'',
    body_85:'',

    header_84:'',
    body_84:'',

    header_83:'',
    body_83:'',

    header_82:'Aggiornamento dell\'app Android (solo Ypsopump) 02/02/2026',
    body_82:'Gentile utente CamAPS FX, una NUOVA VERSIONE dell\'applicazione sarà disponibile nei prossimi giorni – 1.4(190). DISATTIVA GLI AGGIORNAMENTI AUTOMATICI di CamAPS FX nel Google Play Store per poter selezionare l\'orario di aggiornamento preferito. Per motivi di cybersicurezza, le VERSIONI INFERIORI alla 1.4(190) saranno DISCONTINUATE il 31 marzo. Per qualsiasi domanda, contatta il Servizio Clienti mylife-Diabetescare.',

    header_81:'',
    body_81:'',

    header_80:'',
    body_80:'',

    header_79:'',
    body_79:'',

    header_78:'',
    body_78:'',

    header_77:'Messaggio da mylife-Diabetescare (solo YpsoPump) 17/12/2025',
    body_77:'Solo per l\'IT - Importante! Ricarica da oggi i tuoi serbatoi mylife Reservoir: un gesto che fa la differenza. Grazie per il tuo contributo alla sostenibilità!',

    header_76:'',
    body_76:'',

    header_75:'',
    body_75:'',

    header_74:'Messaggio da mylife-Diabetescare (solo YpsoPump) 09/12/2025',
    body_74:'Puoi ricaricare il tuo serbatoio mylife YpsoPump Reservoir una volta entro 7 giorni dal primo riempimento. Scopri di più nella pagina del Serbatoio del sito web mylife-diabetescare.',

    header_73:'',
    body_73:'',
    body_73_link_text:'',
    body_73_end: '',
    body_73_link:'',

    header_72:'',
    body_72:'',
    body_72_link_text:'',
    body_72_end: '',
    body_72_link:'',

    header_71:'',
    body_71:'',
    body_71_link_text:'',
    body_71_end: '',
    body_71_link:'',

    header_70:'Informazioni importanti sulla sicurezza relative al sensore del sistema FreeStyle Libre 3 25/11/2025',
    body_70:'Abbott ha identificato che alcuni sensori FreeStyle Libre 3 e FreeStyle Libre 3 Plus possono mostrare letture di glucosio falsamente basse. Vai su',
    body_70_link_text:'www.FreeStyleCheck.com',
    body_70_end: ' per verificare se il/i tuo/i sensore/i attuale/i o inutilizzato/i è/sono potenzialmente interessato/i. Se le letture del sensore non corrispondono ai tuoi sintomi o alle tue aspettative, disattiva l\'Auto-mode e utilizza un misuratore della glicemia per prendere decisioni terapeutiche. Se hai domande o devi segnalare problemi relativi al sensore del sistema FreeStyle Libre 3, contatta l\'Assistenza Clienti Abbott al 800088244. Il numero di serie dell\'attuale sensore è riportato nel menu dell\'applicazione alla voce Sensore.',
    body_70_link:'https://www.FreeStyleCheck.com',
	
    header_69:'Aggiornamento app iOS (solo YpsoPump) 25/11/2025',
    body_69:'Caro utente mylife CamAPS FX, una NUOVA VERSIONE dell\'applicazione sarà disponibile nei prossimi giorni. DISATTIVA GLI AGGIORNAMENTI AUTOMATICI di CamAPS FX nell\'App Store per selezionare il tuo momento di aggiornamento preferito. La tua versione attuale sarà DISMESSA il 9 dicembre 2025. Se hai domande, contatta il Servizio Clienti Ypsomed.',
	
    header_68:'',
    body_68:'',
	
    header_67:'',
    body_67:'',

    header_66:'',
    body_66:'',
    body_66_link_text:'',
    body_66_end: '',
    body_66_link:'',

    header_65:'',
    body_65:'',
    body_65_link_text:'',
    body_65_end: '',
    body_65_link:'',

    header_64:'',
    body_64:'',
    body_64_link_text:'',
    body_64_end: '',
    body_64_link:'',

    header_63:'',
    body_63:'',
    body_63_link_text:'',
    body_63_end: '',
    body_63_link:'',

    header_62:'AVVISO DI SICUREZZA 28/10/2025',
    body_62:'Si prega di leggere dell\'importante avviso',
    body_62_link_text:'N-0125',
    body_62_end: '. Vai al menu dell\'app -> Notifiche di sicurezza.',
    body_62_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Field+Safety+Notice+ET8374+Mylife+Users+IT+final.pdf',

    header_61:'Aggiornamento app iOS (solo YpsoPump) 02/10/2025',
    body_61:'Per prestazioni ottimali dell\'app, si prega di AGGIORNARE il proprio mylife CamAPS FX all\'ULTIMA VERSIONE (1.4(192)) tramite l\'Apple App Store.',

    header_60:'',
    body_60:'',

    header_59:'Aggiornamento app iOS (solo YpsoPump) 22/09/2025',
    body_59:'Caro utente di mylife CamAPS FX, una NUOVA VERSIONE dell\'applicazione sarà disponibile nei prossimi giorni. DISATTIVA GLI AGGIORNAMENTI AUTOMATICI DI CamAPS FX nell\'App Store per selezionare il momento dell\'aggiornamento preferito. Una nuova versione del manuale utente sarà disponibile. Se hai domande, ti preghiamo di contattare il Servizio Clienti Ypsomed.',

    header_58:'Uscita di iOS 26 (solo YpsoPump) 13/09/2025',
    body_58:'Apple rilascerà presto iOS 26. Per garantire un utilizzo continuo dell\'applicazione mylife CamAPS FX, si prega di controllare il sito web del produttore del sensore per verificare la compatibilità tra smartphone e sistema operativo prima di aggiornare il tuo iPhone a iOS 26. Nota: gli aggiornamenti automatici potrebbero essere attivati di default nelle impostazioni del tuo telefono, si prega di disattivarli.',

    header_57:'Aggiornamento dell\'app Android (solo YpsoPump) 26/08/2025',
    body_57:'Caro utente di mylife CamAPS FX, una nuova versione dell\'applicazione sarà disponibile nei prossimi 2-3 giorni. Si prega di scegliere il proprio orario di aggiornamento preferito disattivando l\'aggiornamento automatico per CamAPS FX nel Google Play Store. Una nuova versione del manuale utente sarà disponibile. Se hai domande, contatta il servizio clienti Ypsomed.',

    header_56:'',
    body_56:'',

    header_55:'',
    body_55:'',

    header_54:'',
    body_54:'',

    header_53:'',
    body_53:'',
	
	header_52:'',
    body_52:'',
	
	header_51:'',
    body_51:'',

    header_50:'',
    body_50:'',

    header_49:'Interruzione delle vecchie versioni dell\'app 01/07/2025',
    body_49:'La versione attuale smetterà di funzionare il 1º agosto 2025. Si prega di aggiornare l\'applicazione all\'ultima versione disponibile su Google Play.',

    header_48:'OS 10 & 11 25/06/2025',
    body_48:'Per motivi di cyber security, dal 1º agosto 2025, mylife CamAPS FX sarà supportato solo su telefoni in lista di compatibilità del sensore e con sistemi operativi Android 12 e superiori. Gli utenti dei sistemi operativi inferiori a OS 12 non potranno più aggiornare o reinstallare mylife CamAPS FX dopo questa data.',

    header_47:'Versione iOS (solo YpsoPump) 09/06/2025',
    body_47:'L\'app mylife CamAPS FX è ora disponibile anche per iPhone! Se sta valutando di passare a iOS, visiti la sezione “Informazioni importanti per gli utenti iOS” su www.mylife-diabetescare.com/it-IT/mylife-loop.html.',

    header_46:'',
    body_46:'',

    header_45:'Sistema operativo Android 16 09/06/2025',
    body_45:'Per garantire un uso ininterrotto dell\'applicazione mylife CamAPS FX, prima di effettuare l\'aggiornamento a Android OS 16 controlla il sito web del produttore del sensore e verificane la compatibilità. Nota: Gli aggiornamenti automatici potrebbero essere attivati per impostazione predefinita nelle impostazioni del tuo telefono.',

    header_44:'Aggiornamento del manuale utente 20/05/2025',
    body_44:'Existe una versión actualizada del manual de usuario.',

    header_43:'',
    body_43:'',

    header_42:'',
    body_42:'',
	
    header_41:'',
    body_41:'',

    header_40:'Nuovo aggiornamento (18/03/2025)',
    body_40:'Caro utente di mylife CamAPS FX, Una nuova versione dell\'app sarà pronta nelle prossime 48 ore. Per scegliere il momento preferito per l\'aggiornamento, disattiva l\'aggiornamento automatico per CamAPS FX nel Google Play Store. Se hai domande, contatta il servizio clienti di Ypsomed.',

    header_39:'',
    body_39:'',

    header_38:'',
    body_38:'',

    header_37:'Interruzione della vecchia versione dell\'app (solo Ypsopump)',
    body_37:'La versione attuale smetterà di funzionare il 7 febbraio 2025. Si prega di aggiornare l\'applicazione all\'ultima versione disponibile su Google Play.',

    header_36:'Una nuova versione dell\'app 06/01/2025',
    body_36:'Caro utente di mylife CamAPS FX, Una nuova versione dell\'app sarà pronta nelle prossime 24 ore. Per scegliere il momento preferito per l\'aggiornamento, disattiva l\'aggiornamento automatico per CamAPS FX nel Google Play Store. Se hai domande, contatta il servizio clienti di Ypsomed.',	

	header_35:'OS 8 & 9 29/12/2024',
    body_35:'Per motivi di cyber security, dal 1º gennaio 2025, mylife CamAPS FX sarà supportato solo su telefoni in lista di compatibilità del sensore e con sistemi operativi Android 10 e superiori. Gli utenti dei sistemi operativi inferiori a OS 10 non potranno più aggiornare o reinstallare mylife CamAPS FX dopo questa data. Promemoria, il sistema non è ancora compatibile con OS15.',
	
	header_34:'',
    body_34:'',
	
	header_33:'Avviso di Manutenzione Programmata',
    body_33:'A causa della manutenzione programmata del servizio cloud di CamAPS FX, la funzionalità Companion sarà non disponibile il 7 dicembre dalle 10:00 GMT per circa tre ore. Ci scusiamo per gli eventuali disagi che ciò potrebbe causare.',
	
	header_32:'Aggiornamento del manuale utente 28/11/2024',
    body_32:'È disponibile una versione aggiornata del manuale d\'uso.',
	
	header_31:'Una nuova versione dell\'app 17/11/2024',
    body_31:'Caro utente di mylife CamAPS FX, Una nuova versione dell\'app sarà pronta nelle prossime 24 ore. Per scegliere il momento preferito per l\'aggiornamento, disattiva l\'aggiornamento automatico per CamAPS FX nel Google Play Store. Se hai domande, contatta il servizio clienti di Ypsomed.',
	
	header_30:'OS 8 & 9 11/10/2024',
    body_30:'Per motivi di cyber security, dal 1º gennaio 2025, mylife CamAPS FX sarà supportato solo su telefoni in lista di compatibilità del sensore e con sistemi operativi Android 10 e superiori. Gli utenti dei sistemi operativi inferiori a OS 10 non potranno più aggiornare o reinstallare mylife CamAPS FX dopo questa data',
	
	header_29:'Una nuova versione dell\'app 09/10/2024',
    body_29:'Caro utente di mylife CamAPS FX, Una nuova versione dell\'app sarà pronta nelle prossime 48 ore. Per scegliere il momento preferito per l\'aggiornamento, disattiva l\'aggiornamento automatico per CamAPS FX nel Google Play Store. Se hai domande, contatta il servizio clienti di Ypsomed.',
	
	header_28:'OS 8 & 9 08/07/2024',
    body_28:'Per motivi di cyber security, dal 1º gennaio 2025, mylife CamAPS FX sarà supportato solo su telefoni in lista di compatibilità del sensore e con sistemi operativi Android 10 e superiori. Gli utenti dei sistemi operativi inferiori a OS 10 non potranno più aggiornare o reinstallare mylife CamAPS FX dopo questa data',
	
	header_27:'',
    body_27:'',

	header_26:'Aggiornamento del manuale utente 11/05/2024',
    body_26:'È disponibile una versione aggiornata del manuale d\'uso.',
	
	header_25:'Una nuova versione dell\'app 05/05/2024',
    body_25:'Caro utente di mylife CamAPS FX, Una nuova versione dell\'app sarà pronta nelle prossime 24 ore. Per scegliere il momento preferito per l\'aggiornamento, disattiva l\'aggiornamento automatico per CamAPS FX nel Google Play Store. Se hai domande, contatta il servizio clienti di Ypsomed.',
	
	header_24:'Una nuova versione dell\'app 24/04/2024',
    body_24:'Caro utente di mylife CamAPS FX, Una nuova versione dell\'app sarà pronta nelle prossime 24 ore. Per scegliere il momento preferito per l\'aggiornamento, disattiva l\'aggiornamento automatico per CamAPS FX nel Google Play Store. Se hai domande, contatta il servizio clienti di Ypsomed.',
	
	header_23:'',
    body_23:'',
	
	header_22:'Aggiornamento del manuale utente 21/04/2024',
    body_22:'È disponibile una versione aggiornata del manuale d\'uso.',
	
	header_21:'',
    body_21:'',
	
	header_20:'',
    body_20:'',
	
	header_19:'',
    body_19:'',

    header_18:'',
    body_18:'',

    header_17:'',
    body_17:'',

	header_16:'Aggiornamento del manuale utente 04/03/2024',
    body_16:'È disponibile una versione aggiornata del manuale d\'uso.',
	
	header_15:'Aggiornamento del manuale utente 04/01/2024',
    body_15:'È disponibile una versione aggiornata del manuale d\'uso.',
	
	header_14:'Android OS 14 22/11/2023',
    body_14:'Promemoria: Per garantire un uso ininterrotto dell\'applicazione mylife CamAPS FX, prima di effettuare l\'aggiornamento a Android OS 14 controlla il sito web del produttore del sensore e verificane la compatibilità. Nota: Gli aggiornamenti automatici potrebbero essere attivati per impostazione predefinita nelle impostazioni del tuo telefono.',
	
	header_13:'AVVISO DI SICUREZZA 14/11/2023',
    body_13:'AVVISO DI SICUREZZA ',
    body_13_link_text:'Si prega di leggere dell\'importante avviso',
    body_13_end: '. Vai al menu dell\'app -> Notifiche di sicurezza.',
    body_13_link:'https://s3.eu-west-1.amazonaws.com/camaps.safety.notices/Field+Safety+Notice+ET5604+Mylife+Users+final-+IT.pdf',

	header_12:'Aggiornamento del manuale utente 10/11/2023',
    body_12:'È disponibile una versione aggiornata del manuale d\'uso.',
	
	header_11:'Android OS 14 12/09/2023',
    body_11:'Per garantire un uso ininterrotto dell\'applicazione mylife CamAPS FX, prima di effettuare l\'aggiornamento a Android OS 14 controlla il sito web del produttore del sensore e verificane la compatibilità. Nota: Gli aggiornamenti automatici potrebbero essere attivati per impostazione predefinita nelle impostazioni del tuo telefono.Assicurarsi di stare utilizzando l\'app mylife CamAPS FX versione 1.4(173) prima di aggiornare ad Android OS 14.',
	
	header_10:'AVVISO DI SICUREZZA 15/08/2023',
    body_10:'AVVISO DI SICUREZZA Si prega di leggere dell\'importante avviso. Vai al menu dell\'app -> Notifiche di sicurezza.',
	
	header_9:'Aggiornamento del manuale utente 27/07/2023',
    body_9:'È disponibile una versione aggiornata del manuale d\'uso.',
	
	header_8:'Compatibilità di Glooko 21/07/2023',
    body_8:'Come annunciato all\'inizio di quest\'anno, diasend sarà interrotto il 28 luglio. Se desideri continuare a condividere i dati con il tuo team diabetologico, aggiorna il tuo account Diasend a Glooko o crea un nuovo account Glooko. Aggiorna alla versione più recente di mylife CamAPS FX, inserisci il tuo nuovo nome utente e password Glooko nel menu di condivisione e riavvia il tuo smartphone. Diasend rimarrà disponibile per la visualizzazione dei dati storici per il resto dell\'anno.',
	
	header_7:'Samsung A-Series 17/07/2023',
    body_7:'Gli utenti di modelli Samsung A-Series (ad esempio A53, A33) potrebbero aver riscontrato una perdita di segnale al sensore CGM dopo l\'ultimo aggiornamento di Samsung One UI 5.1. Samsung ha identificato il problema e una soluzione è in fase di sviluppo. Samsung prevede di rilasciare un aggiornamento a One UI il 24 luglio (a seconda della regione), che risolverà il problema della perdita di segnale. Si consiglia di installare l\'aggiornamento quando sarà disponibile. Se non hai ancora aggiornato a One UI 5.1, ti consigliamo di attendere il prossimo aggiornamento di Samsung One UI.',

    header_6:'Compatibilità di Glooko 08/06/2023',
    body_6:'mylife CamAPS FX è compatibile con Glooko. Si prega di aggiornare l\'app mylife CamAPS FX alla versione 1.4(172). Se si condivide dati con una clinica, verrà ricevuta una notifica all\'interno del proprio account diasend esistente quando la clinica effettuerà l\'aggiornamento a Glooko. Una volta completato l\'aggiornamento, inserire il nuovo nome utente e la nuova password di Glooko nel menu di condivisione e riavviare il proprio smartphone. Si prega di effettuare l\'aggiornamento a Glooko entro il 28 luglio 2023. Diasend sarà disponibile per visualizzare i dati storici per il resto dell\'anno.',

    header_5:'',
    body_5:'',

    header_4:'Aggiornamento del manuale utente 27/05/2023',
    body_4:'È disponibile una versione aggiornata del manuale d\'uso.',

    header_3:'Avvisi via SMS  (Solo Ypsopump) 11/05/2023',
    body_3:'Con il prossimo aggiornamento 1.4(171) a metà maggio, sarà possibile attivare fino a 5 follower SMS E utilizzare contemporaneamente la modalità Companion. Per utilizzare la modalità Companion, il telefono dell\'utente deve avere una connessione internet per condividere i dati. Gli utenti devono avere una SIM card per consentire l\'invio di SMS dal loro telefono. Se si utilizza una di queste opzioni, si consiglia di verificare che il proprio piano mobile includa la copertura SMS e/o dati in base all\'opzione utilizzata.',

    header_2:'',
    body_2:'',

    header_1:'',
    body_1:'',
};
